import { render, staticRenderFns } from "./ApproveByTicketDetailsOld.vue?vue&type=template&id=ac7915b0&scoped=true"
import script from "./ApproveByTicketDetailsOld.vue?vue&type=script&lang=js"
export * from "./ApproveByTicketDetailsOld.vue?vue&type=script&lang=js"
import style0 from "./ApproveByTicketDetailsOld.vue?vue&type=style&index=0&id=ac7915b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac7915b0",
  null
  
)

export default component.exports